module.exports = __webpack_public_path__ + "static/img/dunpai.9c60216.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/dunpai.png
// module id = NNoo
// module chunks = 1